import type * as React from 'react';
import { ConfirmDeleteDialog } from '@verclam/ui-kit';

type Props = {
	readonly visible: boolean;
	/** Already formatted `JJ/MM/AAAA` — the text the user types back. */
	readonly conductedOnDisplay: string;
	readonly onHide: () => void;
	readonly onAccept: () => void;
};

/** Confirms the erasure of the recording and of its local record: there is audio, and it is not recoverable. */
const DiscardLocalDataDialog: React.FC<Props> = ({ visible, conductedOnDisplay, onHide, onAccept }) => {
	return (
		<ConfirmDeleteDialog
			visible={visible}
			onHide={onHide}
			header="Supprimer les données de cet appareil"
			message={`L'enregistrement du ${conductedOnDisplay} et ses informations seront définitivement supprimés de cet appareil. Cette action est irréversible. Saisissez cette date pour confirmer.`}
			confirmText={conductedOnDisplay}
			acceptLabel="Supprimer définitivement"
			rejectLabel="Annuler"
			acceptCallback={onAccept}
		/>
	);
};

export default DiscardLocalDataDialog;
